import { useState } from 'react';
import { getPromocionesPref, setPromocionesPref } from '../lib/notifications';
import { campanaVigente } from '../lib/notificacionesLanzamiento';

// El mismo consentimiento visible en la hoja de bienvenida y en Ajustes.
// Abrir o cerrar la hoja nunca lo acepta ni inicia una prueba gratuita.
export default function PreferenciaPromociones({ userId }) {
  const [activo, setActivo] = useState(() => getPromocionesPref(userId));
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  async function cambiar() {
    setGuardando(true);
    setError('');
    const siguiente = !activo;
    try {
      const efectivo = await setPromocionesPref(siguiente, userId);
      setActivo(efectivo);
      if (siguiente && !efectivo) setError('Para recibir estos avisos, permite las notificaciones de MiPAE en los ajustes del teléfono.');
    } catch {
      // La preferencia pudo guardarse aunque el sistema no cancelara la cola.
      setActivo(getPromocionesPref(userId));
      setError('No pudimos aplicar el cambio en el teléfono. Inténtalo de nuevo desde Ajustes.');
    } finally { setGuardando(false); }
  }
  return (
    <div>
      <label className="flex min-h-[44px] cursor-pointer items-center justify-between gap-3 text-small font-sans text-ink">
        <span>
          <span className="font-semibold">Novedades y promociones</span>
          <span className="mt-1 block text-small leading-relaxed text-ink-subtle">
            Quiero recibir notificaciones sobre funciones nuevas y promociones de MiPAE, incluidas pruebas gratuitas.
            {campanaVigente() && ' Hasta el 25 de octubre pueden ser dos al día.'}
            {' Puedes desactivarlas en Ajustes. Esta preferencia se aplica en este teléfono.'}
          </span>
        </span>
        <input
          type="checkbox"
          aria-label="Recibir novedades y promociones"
          checked={activo}
          disabled={guardando}
          onChange={cambiar}
          className="h-6 w-6 shrink-0 accent-accent"
        />
      </label>
      {error && <p role="alert" className="mt-2 text-small font-sans text-system-error">{error}</p>}
    </div>
  );
}
